module.exports = __webpack_public_path__ + "img/calendar.21fcf295.svg";